import { getCookie, setCookie } from '@r-and-a-shared-ui/utils';
import { PP_Auth_Token } from '@r-and-a-shared-ui/utils';

export const getPPAuthToken = async (authTokenMutation: any) => {
  const storedToken = getCookie(PP_Auth_Token);

  if (storedToken) {
    return storedToken;
  }

  const response: any = await authTokenMutation();

  if (response?.hasErrors) {
    console.error(`Error fetching auth token: ${response.message}`);
    return null;
  }

  const token = response?.accessToken;
  setCookie(PP_Auth_Token, token, response?.expiresIn);

  return token;
};
